import { z } from "zod";

// Subscription status as returned by the API
export const subscriptionStatusSchema = z.enum([
  "ACTIVE",
  "TRIALING",
  "PAST_DUE",
  "CANCELED",
  "INCOMPLETE",
]);

export type SubscriptionStatus = z.infer<typeof subscriptionStatusSchema>;

// Subscription tier
export const subscriptionTierSchema = z.enum(["FREE", "PRO", "ULTIMATE"]);

export type SubscriptionTier = z.infer<typeof subscriptionTierSchema>;

// GET /api/billing/checkout-url response
export const checkoutUrlResponseSchema = z.object({
  proCheckoutUrl: z.string().url(),
  ultimateCheckoutUrl: z.string().url().optional(),
});

export type CheckoutUrlResponse = z.infer<typeof checkoutUrlResponseSchema>;

// GET /api/billing/subscription response
export const subscriptionResponseSchema = z.object({
  id: z.string(),
  tier: subscriptionTierSchema,
  status: subscriptionStatusSchema,
  lsCurrentPeriodEnd: z.string().nullable(),
  lsStatus: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type SubscriptionResponse = z.infer<typeof subscriptionResponseSchema>;

// DELETE /api/billing/subscription response
export const cancelSubscriptionResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
});

export type CancelSubscriptionResponse = z.infer<typeof cancelSubscriptionResponseSchema>;

// Subscription summary on the user profile (from /auth/me)
export const userSubscriptionSchema = z
  .object({
    status: subscriptionStatusSchema.nullable(),
    tier: subscriptionTierSchema.nullable(),
  })
  .nullable();

export type UserSubscription = z.infer<typeof userSubscriptionSchema>;
